import { RESET_EVALUATOR_REGISTER_FORM, RESET_REGISTER_FORM, UPDATE_EVALUATOR_REGISTER_FORM, UPDATE_REGISTER_FORM } from './actions'
import { IHotsiteEvaluatorRegisterForm, IHotsiteRegisterForm } from './contracts'

export const REGISTER_FORM_INITIAL_STATE: IHotsiteRegisterForm = {
  form: {
    id: { value: '', isRequired: false, isInvalid: false, message: '' },
    lineOne: { value: '', isRequired: true, isInvalid: false, message: '' },
    lineTwo: { value: '', isRequired: false, isInvalid: false, message: '' },
    number: { value: '', isRequired: true, isInvalid: false, message: '' },
    neighborhood: { value: '', isRequired: true, isInvalid: false, message: '' },
    zipcode: { value: '', isRequired: true, isInvalid: false, message: '' },
    city: { value: '', isRequired: true, isInvalid: false, message: '' },
    state: { value: '', isRequired: true, isInvalid: false, message: '' },
    country: { value: '', isRequired: true, isInvalid: false, message: '' },
    evaluatorType: { value: '', isRequired: true, isInvalid: false, message: '' },
    otherEvaluatorType: { value: '', isRequired: false, isInvalid: false, message: '' },
    startupName: { value: '', isRequired: true, isInvalid: false, message: '' },
    contactName: { value: '', isRequired: true, isInvalid: false, message: '' },
    email: { value: '', isRequired: true, isInvalid: false, message: '' },
    cnpj: { value: '', isRequired: true, isInvalid: false, message: '' },
    pitch: { value: '', isRequired: true, isInvalid: false, message: '' },
    startupWebsite: { value: '', isRequired: false, isInvalid: false, message: '' },
    phone: { value: '', isRequired: true, isInvalid: false, message: '' },
    password: { value: '', isRequired: true, isInvalid: false, message: '' },
    confirmPassword: { value: '', isRequired: true, isInvalid: false, message: '' },
    activity: { value: '', isRequired: true, isInvalid: false, message: '' },
    target: { value: '', isRequired: true, isInvalid: false, message: '' },
    businessModel: { value: '', isRequired: true, isInvalid: false, message: '' },
    numberEmployees: { value: '', isRequired: true, isInvalid: false, message: '' },
    technologies: { value: '', isRequired: true, isInvalid: false, message: '' },
    developmentStage: { value: '', isRequired: true, isInvalid: false, message: '' },
    annualTurnover: { value: '', isRequired: true, isInvalid: false, message: '' },
    hasRaisedInvestment: { value: '', isRequired: true, isInvalid: false, message: '' },
    amount: { value: '', isRequired: false, isInvalid: false, message: '' },
    investmentSource: { value: '', isRequired: false, isInvalid: false, message: '' },
    otherInvestmentSource: { value: '', isRequired: false, isInvalid: false, message: '' },
    evaluatorRole: { value: '', isRequired: true, isInvalid: false, message: '' },
    evaluatorInstitution: { value: '', isRequired: true, isInvalid: false, message: '' },
    evaluatorDepartment: { value: '', isRequired: true, isInvalid: false, message: '' },
    evaluatorEducation: { value: '', isRequired: true, isInvalid: false, message: '' },
    startupLogo: { value: '', isRequired: true, isInvalid: false, message: '' },
    metWeb: { value: '', isRequired: true, isInvalid: false, message: '' }
  },
  acceptUserTerms: false,
  acceptEcosystemTerms: false,
  isFormValid: false
}

export const EVALUATOR_REGISTER_FORM_INITIAL_STATE: any = {
  form: {
    lineOne: { value: '', isRequired: true, isInvalid: false, message: '' },
    lineTwo: { value: '', isRequired: false, isInvalid: false, message: '' },
    number: { value: '', isRequired: true, isInvalid: false, message: '' },
    neighborhood: { value: '', isRequired: true, isInvalid: false, message: '' },
    zipcode: { value: '', isRequired: false, isInvalid: false, message: '' },
    city: { value: '', isRequired: true, isInvalid: false, message: '' },
    state: { value: '', isRequired: true, isInvalid: false, message: '' },
    contactName: { value: '', isRequired: true, isInvalid: false, message: '' },
    email: { value: '', isRequired: true, isInvalid: false, message: '' },
    phone: { value: '', isRequired: true, isInvalid: false, message: '' },
    password: { value: '', isRequired: true, isInvalid: false, message: '' },
    confirmPassword: { value: '', isRequired: true, isInvalid: false, message: '' },
    evaluatorType: { value: '', isRequired: true, isInvalid: false, message: '' },
    otherEvaluatorType: { value: '', isRequired: false, isInvalid: false, message: '' },
    evaluatorRole: { value: '', isRequired: true, isInvalid: false, message: '' },
    evaluatorInstitution: { value: '', isRequired: true, isInvalid: false, message: '' },
    evaluatorDepartment: { value: '', isRequired: true, isInvalid: false, message: '' },
    evaluatorEducation: { value: '', isRequired: true, isInvalid: false, message: '' }
  },
  acceptUserTerms: false,
  isFormValid: false
}
export interface IHotsiteRegisterFormStateAction {
  type: string
  payload: IHotsiteRegisterForm
}

export interface IHotsiteEvaluatorRegisterFormStateAction {
  type: string
  payload: IHotsiteEvaluatorRegisterForm
}

export const HotsiteRegisterFormReducer = (
  state: IHotsiteRegisterForm = REGISTER_FORM_INITIAL_STATE,
  action: IHotsiteRegisterFormStateAction
): any => {
  switch (action.type) {
    case UPDATE_REGISTER_FORM:
      return {
        ...state,
        ...action.payload
      }

    case RESET_REGISTER_FORM:
      return {
        form: {
          lineOne: { value: '', isRequired: true, isInvalid: false, message: '' },
          lineTwo: { value: '', isRequired: false, isInvalid: false, message: '' },
          number: { value: '', isRequired: true, isInvalid: false, message: '' },
          neighborhood: { value: '', isRequired: true, isInvalid: false, message: '' },
          zipcode: { value: '', isRequired: true, isInvalid: false, message: '' },
          city: { value: '', isRequired: true, isInvalid: false, message: '' },
          state: { value: '', isRequired: true, isInvalid: false, message: '' },
          country: { value: '', isRequired: true, isInvalid: false, message: '' },
          startupName: { value: '', isRequired: true, isInvalid: false, message: '' },
          contactName: { value: '', isRequired: true, isInvalid: false, message: '' },
          email: { value: '', isRequired: true, isInvalid: false, message: '' },
          cnpj: { value: '', isRequired: true, isInvalid: false, message: '' },
          pitch: { value: '', isRequired: true, isInvalid: false, message: '' },
          startupWebsite: { value: '', isRequired: true, isInvalid: false, message: '' },
          phone: { value: '', isRequired: true, isInvalid: false, message: '' },
          password: { value: '', isRequired: true, isInvalid: false, message: '' },
          confirmPassword: { value: '', isRequired: true, isInvalid: false, message: '' },
          activity: { value: '', isRequired: true, isInvalid: false, message: '' },
          businessModel: { value: '', isRequired: true, isInvalid: false, message: '' },
          numberEmployees: { value: '', isRequired: true, isInvalid: false, message: '' },
          technologies: { value: '', isRequired: true, isInvalid: false, message: '' },
          developmentStage: { value: '', isRequired: true, isInvalid: false, message: '' },
          annualTurnover: { value: '', isRequired: true, isInvalid: false, message: '' },
          hasRaisedInvestment: { value: '', isRequired: true, isInvalid: false, message: '' },
          amount: { value: '', isRequired: false, isInvalid: false, message: '' },
          investmentSource: { value: '', isRequired: false, isInvalid: false, message: '' },
          otherInvestmentSource: { value: '', isRequired: false, isInvalid: false, message: '' },
          startupLogo: { value: '', isRequired: true, isInvalid: false, message: '' },
          metWeb: { value: '', isRequired: true, isInvalid: false, message: '' },
        },
        acceptUserTerms: false,
        isFormValid: false
      }

    default:
      return state
  }
}

export const HotsiteEvaluatorRegisterFormReducer = (
  state: IHotsiteEvaluatorRegisterForm = EVALUATOR_REGISTER_FORM_INITIAL_STATE,
  action: IHotsiteEvaluatorRegisterFormStateAction
): any => {
  switch (action.type) {
    case UPDATE_EVALUATOR_REGISTER_FORM:
      return {
        ...state,
        ...action.payload
      }

    case RESET_EVALUATOR_REGISTER_FORM:
      return {
        form: {
          lineOne: { value: '', isRequired: true, isInvalid: false, message: '' },
          lineTwo: { value: '', isRequired: false, isInvalid: false, message: '' },
          number: { value: '', isRequired: true, isInvalid: false, message: '' },
          neighborhood: { value: '', isRequired: true, isInvalid: false, message: '' },
          zipcode: { value: '', isRequired: false, isInvalid: false, message: '' },
          city: { value: '', isRequired: true, isInvalid: false, message: '' },
          state: { value: '', isRequired: true, isInvalid: false, message: '' },
          contactName: { value: '', isRequired: true, isInvalid: false, message: '' },
          email: { value: '', isRequired: true, isInvalid: false, message: '' },
          phone: { value: '', isRequired: true, isInvalid: false, message: '' },
          password: { value: '', isRequired: true, isInvalid: false, message: '' },
          confirmPassword: { value: '', isRequired: true, isInvalid: false, message: '' }
        },
        acceptUserTerms: false,
        isFormValid: false
      }

    default:
      return state
  }
}
